/**
 * @template T
 * @template Y
 * @template N
 * @typedef {0 extends (1 & T) ? Y : N} IfAny
 */

/**
 * @template T
 * @param {Extract<T, string>} key 
 * @returns {IfAny<T, URLSearchParams, string | null>}
 */
export const getSearchParams = (key) => {
  const searchParams = new URLSearchParams(window.location.search)
  return key ? searchParams.get(key) : searchParams
}
